/**
 * Automatically imports all the modules and exports as a single module object
 */
const requireModule = require.context(".", false, /\.module\.js$/);
const commonModules = {};

requireModule.keys().forEach((filename) => {
  // create the module name from fileName
  // remove the module.js extension and capitalize
  const moduleName = filename.replace(/(\.\/|\.module\.js)/g, "");

  commonModules[moduleName] = requireModule(filename).default || requireModule(filename);
});

export default commonModules;
